import { useCallback } from "react";
import { useRevealingMessageStore } from "../stores/useRevealingMessageStore";
import { downloadFile } from "../utils/downloadFile";
import { generateTranscript } from "../utils/transcriptGenerator";

export const useDownloadTranscript = () => {
  const { visibleMessages } = useRevealingMessageStore();

  const downloadTranscript = useCallback(() => {
    if (visibleMessages.length === 0) return;

    const transcript = generateTranscript(visibleMessages);
    const timestamp = Math.floor(Date.now() / 1000);
    const filename = `transcript_${timestamp}.txt`;

    downloadFile(transcript, filename);
  }, [visibleMessages]);

  return { downloadTranscript };
};
